import { createContext, useState } from "react";

const CurrentItemBeingReturnedContext = createContext({
  currentItemBeingReturned: undefined,
  setCurrentItemBeingReturned: (currentItemBeingReturned: any) => {},
});

const CurrentItemBeingReturnedContextProvider = ({ children }) => {
  const [currentItemBeingReturned, setCurrentItemBeingReturned] =
    useState(undefined);

  return (
    <CurrentItemBeingReturnedContext.Provider
      value={{ currentItemBeingReturned, setCurrentItemBeingReturned }}
    >
      {children}
    </CurrentItemBeingReturnedContext.Provider>
  );
};

export {
  CurrentItemBeingReturnedContext,
  CurrentItemBeingReturnedContextProvider,
};
